import {
  reveal,
  useInView,
  usePrefersReducedMotion,
} from "@components/animations";
import { Breadcrumbs } from "@components/shared";
import { experiences } from "@demo-data/experience";
import { Container, Stack } from "@mui/system";

export default function ExperiencePage() {
  const reduceMotion = usePrefersReducedMotion();
  const { ref, inView } = useInView<HTMLDivElement>({ once: true });
  const lineVisible = reduceMotion || inView;

  return (
    <Container maxWidth="lg">
      <Stack gap={4}>
        <Breadcrumbs title="experience" description={"My working experience"} />
        <div
          ref={ref}
          className={`anim-timeline ${lineVisible ? "is-visible" : ""}`}
        >
          <span className="anim-timeline__line" aria-hidden="true" />

          {experiences?.map((item, index) => (
            <div
              key={item.id}
              {...reveal(index % 2 === 0 ? "left" : "right", index * 70)}
            >
              <article className="anim-tl-item">
                <span className="anim-tl-item__dot" aria-hidden="true" />
                <div className="anim-tl-item__card">
                  <div className="anim-tl-item__top">
                    <span className="anim-tl-item__role">
                      {item.title}{" "}
                      <span className="anim-tl-item__company">
                        @ {item.company}
                      </span>
                    </span>
                    <span className="anim-tl-item__year">{item.year}</span>
                  </div>
                  <p className="anim-tl-item__stack">{item.hireFor}</p>
                  <p className="anim-tl-item__address">{item.address}</p>
                  <ul className="anim-tl-item__list">
                    {item.role.map((line) => (
                      <li key={line}>{line}</li>
                    ))}
                  </ul>
                </div>
              </article>
            </div>
          ))}
        </div>
      </Stack>
    </Container>
  );
}
